/**
 * tree-i-font
 *
 * Q-Tree 컴포넌트에서 아이콘 폰트를 사용할 수 있도록 기능을 제공한다.
 */

export default {
  name: 'tree-i-font',
  bind (el) {
    // 트리 컴포넌트의 자식 엘리먼트 조회
    for (const child of el.childNodes) {
      // 자식 엘리먼트 목록에서 아이콘 태그 검색
      const iconTag = child.getElementsByTagName('i')

      // 아이콘 태그가 있으면 클래스 변경
      if (iconTag[0]) {
        // 아이콘 클래스명 가져오기
        const targetClass = iconTag[0].textContent || ''

        iconTag[0].className = `secui-icons si-icons ${targetClass} marR5 f16`
        iconTag[0].textContent = ''
      }
    }
  }
}
